// extracted by mini-css-extract-plugin
module.exports = {"freeDeliveryInfos":"D-WlVe","pdpRevamp":"c9Linlh"};